import "./FootnoteNumber.scss";
interface FootnoteProps {
  number: number;
}

export const FootnoteNumber = ({ number }: FootnoteProps) => {
  return <span className="footnote-number">{number})</span>;
};
